import bootstrapCollapse from 'angular-ui-bootstrap/src/collapse';
import bootstrapDropdown from 'angular-ui-bootstrap/src/dropdown';
import { headerMenusComponent } from './header-menus.component';
import { HeaderMenusService } from './header-menus.service';
import './header-menus.scss';

export const headerMenus = angular
	.module('common.header-menus', [
		bootstrapCollapse,
		bootstrapDropdown
	])
	.component('headerMenus', headerMenusComponent)
	.service('HeaderMenusService', HeaderMenusService)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/header-menus/header-menus.module.js